import { render, staticRenderFns } from "./diyblank.vue?vue&type=template&id=04dbe18a&scoped=true&"
import script from "./diyblank.vue?vue&type=script&lang=js&"
export * from "./diyblank.vue?vue&type=script&lang=js&"
import style0 from "./diyblank.vue?vue&type=style&index=0&id=04dbe18a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dbe18a",
  null
  
)

export default component.exports